import styled from 'styled-components'
import { DetailsCard } from '../DetailsCard/DetailsCard'
import { ShopTheLookButton } from '../ShopTheLookButton/ShopTheLookButton'

export const MainContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`

export const MainBlock = styled.div`
  @media (min-width: 992px) {
    display: flex;
    gap: 2rem;
  }

  @media screen and (min-width: 1200px) {
    margin-top: 3.25rem;
  }
`

export const ImageBlock = styled.div`
  @media (min-width: 992px) {
    margin-bottom: 8rem;
    flex: 64.7%;
  }
`

export const ProductSections = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;

  @media screen and (min-width: 768px) {
    margin-top: 6rem;
  }
`

export const ProductInfoBlock = styled.div<{
  hasCollectionBrandName: boolean
  headerHeight: number
}>`
  display: flex;
  flex-direction: column;

  @media (min-width: 992px) {
    align-self: flex-start;
    flex: 35.3%;
    max-width: 39rem;
    margin-top: -2rem;
    padding: 2rem 0;
  }
`

export const GuaranteeIcons = styled.div`
  padding: 0 2rem;
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;

  svg {
    width: 10rem;
    stroke-opacity: 0;

    path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`

export const Sliders = styled.div`
  .product-slider {
    margin-bottom: 4rem;

    @media screen and (min-width: 768px) {
      margin-bottom: 8rem;
    }
  }

  div:last-child {
    .product-slider {
      margin-bottom: 0;
    }
  }
`

export const StyledDetailsCard = styled(DetailsCard)`
  width: 100%;

  @media screen and (min-width: 768px) {
    width: 100%;
    margin-right: 1rem;
  }
`

export const StyledShopTheLookButton = styled(ShopTheLookButton)`
  position: absolute;
  z-index: 2;
  top: 1.2rem;
  left: 1.2rem;

  @media screen and (min-width: 992px) {
    top: 4.2rem;
    left: 4.2rem;
  }
`
